import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home.vue'
import Expert from '../pages/expert.vue'
import News from '../pages/news.vue'
import Document from '../pages/document.vue'
import Device from '../pages/device.vue'
import Honor from '../pages/honor.vue'
import Overview from '../pages/overview.vue'
import Recruit from '../pages/recruit.vue'
import ContacUs from '../pages/contacUs.vue'
import Department from '../pages/department.vue'
import RecruitDs from '../pages/recruitDs.vue'
import NewsDs from '../pages/newsDs.vue'
import Notice from '../pages/notice.vue'
import Noticeds from '../pages/noticeds.vue'

// const Home = (r) => require.ensure([], () => r(require('../pages/home.vue')))
// const Expert = (r) =>
//   require.ensure([], () => r(require('../pages/expert.vue')))
// const News = (r) => require.ensure([], () => r(require('../pages/news.vue')))
// const Document = (r) =>
//   require.ensure([], () => r(require('../pages/document.vue')))
// const Device = (r) =>
//   require.ensure([], () => r(require('../pages/device.vue')))
// const Honor = (r) => require.ensure([], () => r(require('../pages/honor.vue')))
// const Overview = (r) =>
//   require.ensure([], () => r(require('../pages/overview.vue')))
// const Recruit = (r) =>
//   require.ensure([], () => r(require('../pages/recruit.vue')))
// const ContacUs = (r) =>
//   require.ensure([], () => r(require('../pages/contacUs.vue')))
// const Department = (r) =>
//   require.ensure([], () => r(require('../pages/department.vue')))
// const RecruitDs = (r) =>
//   require.ensure([], () => r(require('../pages/recruitDs.vue')))
// const NewsDs = (r) =>
//   require.ensure([], () => r(require('../pages/newsDs.vue')))
// const Notice = (r) =>
//   require.ensure([], () => r(require('../pages/notice.vue')))
// const Noticeds = (r) =>
//   require.ensure([], () => r(require('../pages/noticeds.vue')))

Vue.use(Router)

export default new Router({
  mode: 'history', //去掉url中的#
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/expert',
      name: 'Expert',
      component: Expert,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/document',
      name: 'document',
      component: Document,
    },
    {
      path: '/device',
      name: 'device',
      component: Device,
    },
    {
      path: '/honor',
      name: 'honor',
      component: Honor,
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview,
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit,
    },
    {
      path: '/contacUs',
      name: 'contacUs',
      component: ContacUs,
    },
    {
      path: '/department',
      name: 'department',
      component: Department,
    },
    {
      path: '/recruitDs',
      name: 'recruitDs',
      component: RecruitDs,
    },
    {
      path: '/newsDs',
      name: 'newsDs',
      component: NewsDs,
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
    },
    {
      path: '/noticeds',
      name: 'noticeds',
      component: Noticeds,
    },
  ],
})
